import { Loader } from "lucide-react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "danger" | "ghost";
  size?: "sm" | "md" | "lg";
  isLoading?: boolean;
  children: React.ReactNode;
}

const Button = ({
  variant = "primary",
  size = "md",
  isLoading,
  children,
  className = "",
  ...props
}: ButtonProps) => {
  const base = "flex items-center justify-center gap-2 font-medium rounded-lg transition-all duration-200 shadow-sm";

  const variants = {
    primary: "bg-[#2462b2] text-white hover:bg-[#1e52a0] hover:shadow-md",
    danger: "bg-red-50 text-red-700 hover:bg-red-100",
    ghost: "bg-transparent text-gray-700 hover:bg-gray-100"
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-5 py-2.5",
    lg: "px-6 py-3.5 text-lg"
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${sizes[size]} ${isLoading ? "opacity-75" : ""} ${className}`}
      disabled={isLoading || props.disabled}
      {...props}
    >
      {isLoading ? <Loader className="animate-spin" size={16} /> : children}
    </button>
  );
};

export default Button;
